import { Badge, type BadgeColor } from '@civilgrid/ui/components';
import type { ReactNode } from 'react';
import HoverCard from '~/components2/HoverCard';

interface Props {
  title: string;
  color: BadgeColor;
  content: ReactNode;
}

export default function ({ title, color, content }: Props) {
  return (
    <HoverCard
      key={title}
      side="left"
      trigger={
        <div>
          <Badge color={color} className="cursor-help">
            {title}
          </Badge>
        </div>
      }
    >
      <div className="font-medium">{title}</div>
      {content}
    </HoverCard>
  );
}
